export interface UserType {
	name: string;
}
export const UserType = {
    'DIRECTORATE':          {name: 'directorate' },
    'COOP':                 {name: 'coop' },
    'MEMBER':               {name: 'member' },
 };
